/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Content.ExternalResourceType_
///   This is an auto-generated enumeration of the SWFC_Learning.Content.ExternalResourceType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum ExternalResourceType_ {
   /// <summary>
   ///   Web Site (Web)
   /// </summary>
   WebSite = 0,
   /// <summary>
   ///   WorkSheets (W/S)
   /// </summary>
   Worksheet = 2,
   /// <summary>
   ///   Coloring Pages (CP)
   /// </summary>
   ColoringPages = 5,
   /// <summary>
   ///   Activities (Act)
   /// </summary>
   Activities = 6,
   /// <summary>
   ///   Word Searches (WSrchs)
   /// </summary>
   WordSearches = 7,
   /// <summary>
   ///   Dot To Dot (Dot2Dot)
   /// </summary>
   DotToDot = 8
}

export const ExternalResourceTypes: ExternalResourceType[] = [
   {
      code: ExternalResourceType_.WebSite,
      literal: 'WebSite',
      description: 'Web Site',
      shortDescription: 'Web',
      listPriority: 0,

      typeName: "ExternalResourceType"
   },
   {
      code: ExternalResourceType_.Worksheet,
      literal: 'Worksheet',
      description: 'WorkSheets',
      shortDescription: 'W/S',
      listPriority: 3,

      typeName: "ExternalResourceType"
   },
   {
      code: ExternalResourceType_.ColoringPages,
      literal: 'ColoringPages',
      description: 'Coloring Pages',
      shortDescription: 'CP',
      listPriority: 1,

      typeName: "ExternalResourceType"
   },
   {
      code: ExternalResourceType_.Activities,
      literal: 'Activities',
      description: 'Activities',
      shortDescription: 'Act',
      listPriority: 2,

      typeName: "ExternalResourceType"
   },
   {
      code: ExternalResourceType_.WordSearches,
      literal: 'WordSearches',
      description: 'Word Searches',
      shortDescription: 'WSrchs',
      listPriority: 4,

      typeName: "ExternalResourceType"
   },
   {
      code: ExternalResourceType_.DotToDot,
      literal: 'DotToDot',
      description: 'Dot To Dot',
      shortDescription: 'Dot2Dot',
      listPriority: 5,

      typeName: "ExternalResourceType"
   }
]

export class ExternalResourceType implements IDomainModel {
   code: ExternalResourceType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: ExternalResourceType_): ExternalResourceType {
      return ExternalResourceTypes.find(d => d.code === code)
   }
}
